/**
 * Log Hook - Incoming
 *
 * Logs all incoming messages for debugging and diagnostics.
 */

import { BaseHook } from '../base/BaseHook';
import type { IPipelineContext, HookResult } from '../../types';

export class LogHook extends BaseHook {
  readonly name = 'LogHook';

  readonly priority = 10;

  private label: string;

  constructor(label: string = 'MESSAGE') {
    super();
    this.label = label;
  }

  async execute(context: IPipelineContext): Promise<HookResult> {
    const envelope = context.envelope;
    this.logger.info(`[${this.label}] Received on topic "${envelope.meta.topic || '(unknown)'}"`, {
      id: envelope.meta.id,
      type: envelope.meta.type,
      protocol: envelope.meta.protocol,
      transport: envelope.meta.transport,
    });

    return this.continue();
  }
}
